module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.1914/img/video-thumb-overlay.png"